import React, { useContext, useEffect, useState, useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./ECSGeneration.css";
import { apiurl } from "../../../../path";
// import Application from "../../../StateContext/Application.js";
import Application from "../../StateContext/Application.js";
import {
  ApprovePay32,
  AvailableReleaseAmount,
  Balance,
  BillApprovalBlue32,
  Search32,
  SelectedDemandAmount,
  TotalAmountRelease,
  TotalLimitAlloted123,
  TotalProjectCost11,
  TotalWorkOrders,
} from "../../../../public/LoginImages/importimages.js";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext.js";
import GooglePagination from "../../styles/GooglePagination";
import { formatFileName } from "../../../../utils/DateFormat.js";

const ECSGeneration = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const operation = useContext(Application);

  const {
    GetProjectInfo,
    GetBudgetHeadInfo,
    DemandCreation,
    GetDemandApproval,
    ApproveBills,
    GetTotalAmountAvailbaleInBank,
    CreateToken,
    Usermenu,
    Getyears,
    GenerateBankFile,
  } = operation;

  const [selectedImage, setSelectedImage] = useState("");
  const [progressData, setProgressData] = useState([]);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);

  const [projectId, setProjectId] = useState([]);
  const [ALLtableData, setALLTableData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [getAvailableBankBalance, SetAvailableBankBalance] = useState([]);
  const [BankBalance, setBankBalance] = useState([]);
  const [CountBalance, setCountBalance] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showspecific, setShowSpecific] = useState(0);
  const [selectedDemandID, setSelectedDemandID] = useState();
  const [
    fetchSpecificDemandDeductionDetail,
    setfetchSpecficDemandDeductionDetail,
  ] = useState([]);
  // const [filteredBills, setFilteredBills] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const [showAll, setShowAll] = useState(false);
  const billsPerPage = showAll ? tableData.length : 10;

  const totalPages = Math.ceil(tableData?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  //  const sortedBills = Array.isArray(tableData)? tableData.slice() // ✅ prevent state mutation
  // .sort((a, b) => new Date(b.Date) - new Date(a.Date))
  //         : [];
  const sortedBills = tableData;
  const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
  // const currentBills = tableData?.slice(indexOfFirstBill, indexOfLastBill);

  const [data, setData] = useState({
    ProjectName: "",
    ProjectID: "",
    PIU: "",
    AvaiableReleaseAmount: 0,
    SelectedDemandAmount: 0,
    Balance: 0,
  });

  const [hide, sethide] = useState(true);
  const [Etoken, SetEtoken] = useState(false);
  const [GenerateToken, SetGenerateToken] = useState(true);
  const [AdminData, setAdminData] = useState([]);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const [selectedBillData, setSelectedBillData] = useState({});
  const [exportingBillSlipPDF, setExportingBillSlipPDF] = useState(false);
  const billSlipRef = useRef(null);

  // Styles for the bill slip footer sections
  const footerTitleStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "8px",
  };
  const footerTitleTdStyle = {
    border: "1px solid #555",
    padding: "6px",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "bold",
  };
  const remarksTableStyle = { width: "100%", borderCollapse: "collapse" };
  const remarksTableTdStyle = {
    border: "1px solid #555",
    padding: "8px",
    fontSize: "11px",
    lineHeight: "18px",
    textAlign: "right",
  };
  const instructionTableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "-1px",
  };
  const instructionTableTdStyle = {
    border: "1px solid #555",
    padding: "10px",
    fontSize: "11px",
    lineHeight: "18px",
    textAlign: "justify",
  };

  async function GenerateTokenFor(e) {
    e.preventDefault();
    let data = await CreateToken("Demand Approval");
    document.getElementById("tokencopys").innerText = data;
    SetEtoken(data);
    sethide(false);
  }

  const HandleChangeData = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const FetchData = async () => {
    try {
      let res = await GetDemandApproval("GetRecordsforECS");
      let res1 = await GetProjectInfo("null", "all");

      let proposalData = res.map((val) => ({
        ProjectId: val.MainWorkOrderID,
        ProjectName: val.MainWorkOrderID,
      }));

      const seen = new Set();

      const uniqueProposalData = proposalData.filter((item) => {
        const key = item.ProjectId;
        return seen.has(key) ? false : seen.add(key);
      });

      setProjectId(uniqueProposalData);

      console.log("Propdal data *************", proposalData);
      setTableData(res);
      console.log("response ", res);
      setALLTableData(res);
      console.log(res);
      // setHeadID(res1);
    } catch (err) {
      console.log(err);
    }
  };

  //For Fetching Admin details
  const GetAdminData = async () => {
    try {
      let res = await Usermenu();
      console.log(res);
      setAdminData(res.Data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    FetchData();
    GetTotalAmountAvailableInBank();
    GetAdminData();
  }, []);

  const [selectedBills, setSelectedBills] = useState([]);
  const [loading, setLoading] = useState(false);

  // const handleCheckboxChange = (id) => {

  //   setSelectedBills((prevSelected) =>
  //     prevSelected.includes(id)
  //       ? prevSelected.filter((ProjectID) => ProjectID !== id) // Remove if already selected
  //       : [...prevSelected, id] // Add if not selected

  //   );
  // };

  //   const handleCheckboxChange = (id) => {
  //     const bill = tableData.find(b => b.DemandGenerationID === id);
  //     const amount = Number(bill.BillAmount);
  // if (
  //   AdminData.Department_Name === "State" &&
  //   (AdminData.RoleID !== 24)&&
  //   !uploadedFiles[id]
  // ) {
  //   alert("Please Upload Order file first!");
  //   return;
  // }
  //     setSelectedBills((prevSelected) => {
  //       let updated;
  //       if (prevSelected.includes(id)) {
  //         updated = prevSelected.filter((item) => item !== id);
  //         setData(prev => ({
  //           ...prev,
  //           SelectedDemandAmount: prev.SelectedDemandAmount - amount
  //         }));
  //       } else {
  //         updated = [...prevSelected, id];
  //         setData(prev => ({
  //           ...prev,
  //           SelectedDemandAmount: prev.SelectedDemandAmount + amount
  //         }));
  //       }
  //       return updated;
  //     });
  //   };
  const handleCheckboxChange = (id) => {
    const bill = tableData.find((b) => b.DemandGenerationID === id);

    const amount = Number(bill.BillAmount);

    // Upload Work validation
    if (
      AdminData.Department_Name === "State" &&
      AdminData.RoleID != 24 &&
      !uploadedFiles[id]
    ) {
      alert("Please upload work file first!");
      return;
    }

    setSelectedBills((prevSelected) => {
      // Existing selected bill objects
      const selectedBillObjects = tableData.filter((b) =>
        prevSelected.includes(b.DemandGenerationID),
      );

      // District validation
      if (prevSelected.length > 0 && !prevSelected.includes(id)) {
        const firstDistrict = selectedBillObjects[0]?.District;

        if (firstDistrict !== bill.District) {
          alert("You can select bills from the same district only!");
          return prevSelected;
        }
      }

      let updated;

      if (prevSelected.includes(id)) {
        updated = prevSelected.filter((item) => item !== id);

        setData((prev) => ({
          ...prev,
          SelectedDemandAmount: prev.SelectedDemandAmount - amount,
        }));
      } else {
        updated = [...prevSelected, id];

        setData((prev) => ({
          ...prev,
          SelectedDemandAmount: prev.SelectedDemandAmount + amount,
        }));
      }

      return updated;
    });
  };

  const selectedBillDetails = tableData.filter((bill) =>
    selectedBills.includes(bill.DemandGenerationID),
  );

  const selectedBillCount = selectedBillDetails.length;
  const selectedBillAmount = selectedBillDetails.reduce(
    (sum, bill) => sum + Number(bill.BillAmount || 0),
    0,
  );
  console.log("selectedBillAmount", selectedBillDetails);
  const selectedNetPayableAmount = selectedBillDetails.reduce(
    (sum, bill) => sum + Number(bill.NetPayableAmount || 0),
    0,
  );
  const selectedDeductionAmount = selectedBillDetails.reduce(
    (sum, bill) => sum + Number(bill.DeductionAmount || 0),
    0,
  );
  console.log("selectedbills", selectedBills);

  // const approveSelected = async () => {
  //   if (selectedBills.length === 0) {
  //     alert('No bills selected for approval!');
  //     return;
  //   }
  //   console.log(selectedBills);
  //   setLoading(true); // Start loader
  //   try {
  //     let response = await ApproveBills(selectedBills, Etoken); // Call backend function
  //     if (response.message) {
  //       alert(response.message);
  //       window.location.reload()
  //       FetchData(); // Refresh the list after approval
  //     }
  //     if (response.error) {
  //       alert(response.error)
  //       window.location.reload()
  //       FetchData(); // Refresh the list after approval
  //     }
  //   } catch (error) {
  //     console.error('Error approving bills:', error);
  //     alert('An error occurred while approving bills.');
  //     window.location.reload()
  //   }
  //   setLoading(false); // Stop loader
  // };

  const approveSelected = async () => {
    if (selectedBills.length === 0) {
      alert("No bills selected for approval!");
      return;
    }

    // Defensive numeric parse (treat invalid/missing as 0)
    const available = Number(TotalPaidCount) || 0;
    const selectedDemand = Number(data?.SelectedDemandAmount) || 0;

    // if (available < selectedDemand) {
    //   alert(
    //     "Insufficient Available Release Amount. Approval requires Available Release Amount >= Selected Demand Amount.",
    //   );
    //   return;
    // }

    console.log(selectedBills);
    setLoading(true); // Start loader
    // try {
    //   let response = await ApproveBills(selectedBills, Etoken); // Call backend function
    //   if (response.message) {
    //     alert(response.message);
    //     // refresh
    //     FetchData();
    //     window.location.reload();
    //   } else if (response.error) {
    //     alert(response.error);
    //     FetchData();
    //     window.location.reload();
    //   }
    // }
    try {
      let response = await GenerateBankFile(selectedBills, Etoken);

      if (response.message) {
        alert(response.message);

        FetchData();
      } else if (response.error) {
        alert(response.error);

        FetchData();
      }
    } catch (error) {
      console.error("Error approving bills:", error);
      alert("An error occurred while approving bills.");
      // window.location.reload();
    } finally {
      setLoading(false); // Stop loader
    }
  };
  const GetTotalAmountAvailableInBank = async () => {
    let data = await GetTotalAmountAvailbaleInBank();
    console.log(data);
    setBankBalance(data[0]);
    // setCountBalance(data.result1[0])
  };
  let TotalPaidCount = BankBalance.AvailableBalanceinBank;
  console.log(BankBalance);

  const FetchDemandApprovalData = async (e) => {
    e.preventDefault();
    const { ProjectID } = data;
    console.log(ProjectID);

    if (!ProjectID) {
      alert("Required all field priject id and piu name");
      return;
    }

    try {
      let res1 = await GetProjectInfo(ProjectID, "DemandGeneration");
      console.log(res1);

      let result = res1;
      let ans = result.filter((item) => item.ProjectID == ProjectID);

      // setTableData(ans);

      console.log(ans);
    } catch (err) {
      console.log(err);
    }
  };

  const TotalAmount = () => {
    const totalAvaiablereleaseAmount = tableData.reduce(
      (acc, item) => acc + Number(item.BillAmount),
      0,
    );

    setData((prev) => ({
      ...prev,
      AvaiableReleaseAmount: totalAvaiablereleaseAmount,
    }));
  };

  useEffect(() => {
    TotalAmount();
  }, [tableData]);

  const TotalSelectedDemandAmount = (amount) => {
    setData((prev) => ({
      ...prev,
      SelectedDemandAmount:
        Number(prev.SelectedDemandAmount || 0) + Number(amount),
    }));
  };

  // const handleSelectAllChange = (e) => {
  //   const checked = e.target.checked;
  //   setSelectAll(checked);

  //   if (checked) {
  //     const allIds = tableData.map((item) => item.DemandGenerationID);
  //     setSelectedBills(allIds);

  //     // Total of all selected bill amounts
  //     const totalAmount = tableData.reduce((acc, item) => acc + Number(item.BillAmount), 0);
  //     setData((prev) => ({
  //       ...prev,
  //       SelectedDemandAmount: totalAmount
  //     }));
  //   } else {
  //     setSelectedBills([]);
  //     setData((prev) => ({
  //       ...prev,
  //       SelectedDemandAmount: 0
  //     }));
  //   }
  // };

  // const handleSelectAllChange = (e) => {
  //   const checked = e.target.checked;
  //   setSelectAll(checked);

  //   const currentPageBillIDs = currentBills.map((item) => item.DemandGenerationID);

  //   if (checked) {
  //     // Add all currentBills if not already selected
  //     const newSelected = [...new Set([...selectedBills, ...currentPageBillIDs])];
  //     setSelectedBills(newSelected);

  //     // Add only those current page bills that were not already selected
  //     const newlyAdded = currentBills.filter(bill => !selectedBills.includes(bill.DemandGenerationID));
  //     const newAmount = newlyAdded.reduce((acc, item) => acc + Number(item.BillAmount), 0);

  //     setData((prev) => ({
  //       ...prev,
  //       SelectedDemandAmount: prev.SelectedDemandAmount + newAmount
  //     }));
  //   } else {
  //     // Remove only current page bills from selection
  //     const remainingSelected = selectedBills.filter(id => !currentPageBillIDs.includes(id));
  //     setSelectedBills(remainingSelected);

  //     const removedAmount = currentBills.reduce((acc, item) => acc + Number(item.BillAmount), 0);

  //     setData((prev) => ({
  //       ...prev,
  //       SelectedDemandAmount: prev.SelectedDemandAmount - removedAmount
  //     }));
  //   }
  // };

  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;

    // ✅ State department logic
    let validBills = currentBills;

    if (AdminData.Department_Name === "State" && AdminData.RoleID !== 24) {
      validBills = currentBills.filter(
        (item) => uploadedFiles[item.DemandGenerationID],
      );
    }

    // ✅ Check same district before select all
    if (checked && validBills.length > 0) {
      const districtSet = new Set(validBills.map((item) => item.District));

      if (districtSet.size > 1) {
        alert("Please select bills from same district only!");
        return;
      }
    }

    const validBillIDs = validBills.map((item) => item.DemandGenerationID);

    setSelectAll(checked);

    if (checked) {
      const newSelected = [...new Set([...selectedBills, ...validBillIDs])];

      setSelectedBills(newSelected);

      const newlyAdded = validBills.filter(
        (bill) => !selectedBills.includes(bill.DemandGenerationID),
      );

      const newAmount = newlyAdded.reduce(
        (acc, item) => acc + Number(item.BillAmount),
        0,
      );

      setData((prev) => ({
        ...prev,
        SelectedDemandAmount: prev.SelectedDemandAmount + newAmount,
      }));

      // optional alert only for State
      if (
        AdminData.Department_Name === "State" &&
        AdminData.RoleID !== 24 &&
        validBills.length !== currentBills.length
      ) {
        alert("Some bills were skipped because Upload Order file is missing.");
      }
    } else {
      const remainingSelected = selectedBills.filter(
        (id) => !validBillIDs.includes(id),
      );

      setSelectedBills(remainingSelected);

      const removedAmount = validBills.reduce(
        (acc, item) => acc + Number(item.BillAmount),
        0,
      );

      setData((prev) => ({
        ...prev,
        SelectedDemandAmount: prev.SelectedDemandAmount - removedAmount,
      }));
    }
  };
  useEffect(() => {
    if (data.ProjectID) {
      if (data.ProjectID == "All") {
        let res = ALLtableData;
        setTableData(res);
      } else {
        let res = ALLtableData.filter(
          (item) => item.ProjectID === data.ProjectID,
        );
        setTableData(res);
      }
    }
  }, [data.ProjectID]);

  const DemandDeductionDetailByBillID = async (ID) => {
    try {
      let res = await Getyears("FetchDemandDeductionDetailbyBillID", ID);
      setfetchSpecficDemandDeductionDetail(res);
      setSelectedDemandID(ID);
      setShowSpecific(1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const currentPageIDs = currentBills.map((bill) => bill.DemandGenerationID);
    const allSelected = currentPageIDs.every((id) =>
      selectedBills.includes(id),
    );
    setSelectAll(allSelected);
  }, [currentBills, selectedBills]);

  const handleUploadWork = (e, val) => {
    const file = e.target.files[0];

    if (file) {
      setUploadedFiles((prev) => ({
        ...prev,
        [val.DemandGenerationID]: file,
      }));
    }
  };
  console.log("selectedBills", selectedBills);
  const allSelectedBillsHaveFiles =
    selectedBills.length > 0 &&
    currentBills
      .filter((bill) => selectedBills.includes(bill.DemandGenerationID))
      .every((bill) => uploadedFiles[bill.DemandGenerationID]);

  const openProgressModal = (images, location) => {
    console.log("image and location ", images, location);
    try {
      const parsedImages = JSON.parse(images || "[]");
      const parsedLocations = JSON.parse(location || "[na]");

      let imageArray = [];

      parsedImages.forEach((img) => {
        try {
          const nested = JSON.parse(img);

          if (Array.isArray(nested)) {
            imageArray.push(...nested);
          } else {
            imageArray.push(img);
          }
        } catch {
          imageArray.push(img);
        }
      });

      // const combinedData = imageArray.map((image, index) => {
      //   let locationObj = {};

      //   try {
      //     locationObj = JSON.parse(parsedLocations[index] || "{}");
      //   } catch (err) {
      //     console.log(err);
      //   }

      //   return {
      //     image,
      //     location: locationObj,
      //   };
      // });
      const combinedData = imageArray.map((image, index) => {
        let locationObj = {};

        const loc = parsedLocations[index];

        if (loc && loc !== "na" && loc !== "null" && loc !== "") {
          try {
            locationObj = JSON.parse(loc);
          } catch (err) {
            console.error("Invalid location JSON:", loc, err);
          }
        }

        return {
          image,
          location: locationObj,
        };
      });
      console.log("combinedData", combinedData);

      setProgressData(combinedData);
      setShowProgressModal(true);
    } catch (err) {
      console.log(err);
    }
  };

  // Open the Bill Slip for a given Demand ID
  const openBillSlip = async (ID) => {
    try {
      let res = await Getyears("FetchDemandDeductionDetailbyBillID", ID);
      setfetchSpecficDemandDeductionDetail(res);
      setSelectedDemandID(ID);

      const filtered = res.filter((val) => val.DemandGenerationID == ID);
      setSelectedBillData(filtered[0] || {});

      setShowSpecific(2); // ✅ new sub-view, distinct from the Deduction view (1)
    } catch (err) {
      console.log(err);
    }
  };

  const closeBillSlip = () => {
    setfetchSpecficDemandDeductionDetail([]);
    setSelectedBillData({});
    setSelectedDemandID(null);
    setShowSpecific(0);
  };

  const exportBillSlipPDF = async () => {
    if (!billSlipRef.current) {
      alert("Bill slip not found");
      return;
    }
    setExportingBillSlipPDF(true);
    try {
      const canvas = await html2canvas(billSlipRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const maxImgWidth = pageWidth - margin * 2;
      const maxImgHeight = pageHeight - margin * 2;
      const widthRatio = maxImgWidth / canvas.width;
      const heightRatio = maxImgHeight / canvas.height;
      const ratio = Math.min(widthRatio, heightRatio);
      const imgWidth = canvas.width * ratio;
      const imgHeight = canvas.height * ratio;

      pdf.addImage(
        canvas.toDataURL("image/png"),
        "PNG",
        (pageWidth - imgWidth) / 2,
        margin,
        imgWidth,
        imgHeight,
      );

      const transactionNo =
        selectedBillData?.DemandGenerationID || selectedDemandID;
      pdf.save(`Bill_Slip_${transactionNo || "RDD"}.pdf`);
    } catch (error) {
      console.error("Bill slip PDF export error:", error);
      alert("Failed to export bill slip PDF. Please try again.");
    } finally {
      setExportingBillSlipPDF(false);
    }
  };
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!progressData?.length) return;
  
      if (e.key === "ArrowRight") {
        setSelectedImageIndex((prevIndex) =>
          (prevIndex + 1) % progressData.length
        );
      }
  
      if (e.key === "ArrowLeft") {
        setSelectedImageIndex((prevIndex) =>
          (prevIndex - 1 + progressData.length) % progressData.length
        );
      }
  
      // Optional: close image/modal with Escape
      // if (e.key === "Escape") {
      //   setSelectedImageIndex(null);
      // }
    };
  
    window.addEventListener("keydown", handleKeyDown);
  
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [progressData]);
  return (
    <>
      {showspecific === 0 && (
        <div
          className="col-12 DemandApprovalPage"
          style={{ backgroundColor: "#eff3f8" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 4rem",
            }}
          >
            {/* <button className=' px-4 py-2'
              onClick={approveSelected}
              // onClick={(e) => { SetGenerateToken(false) }}
              disabled={selectedBills.length <= 0 ? true : loading}
              style={{
                cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer',
                background: selectedBills.length <= 0 ? (
                  'linear-gradient(to Right,rgba(141, 141, 141, 0.97))'
                ) : ('linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )'), color: 'white',
                fontSize: "16px"
              }}
            ><img src="" style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve & Pay'}
            </button> */}
            {/* <button className='btn btn-success'>Approve & Pay</button> */}
            {/* <button className='btn mx-2' style={{ backgroundColor: "#B6BAC1" }}>Back</button> */}
            <h4 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <img src={BillApprovalBlue32} style={{ width: "1.5rem" }} />
              {t("Bill Approval")}
            </h4>
            <button
              onClick={approveSelected}
              disabled={selectedBills.length <= 0 ? true : loading}
              style={{
                color: "white",
                border: "none",
                borderRadius: "20px",
                padding: "8px 20px",
                fontSize: "14px",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                fontFamily: "sans-serif",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                cursor:
                  selectedBills.length <= 0
                    ? "not-allowed"
                    : loading
                      ? "not-allowed"
                      : "pointer",
                background:
                  selectedBills.length <= 0
                    ? "linear-gradient(to Right,rgba(141, 141, 141, 0.97)"
                    : "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5)",
                color: "white",
              }}
            >
              <img
                src={ApprovePay32}
                style={{ width: "14px", filter: "brightness(0) invert(1)" }}
              />
              {loading
                ? AdminData.Department_Name === "District" ||
                  AdminData.Department_Name === "State"
                  ? "Processing..."
                  : ""
                : AdminData.Role === "RDD Section Officer"
                  ? t("Generate ECS")
                  : t("Generate ECS")}
            </button>
          </div>

          <div
            style={{
              display: "flex",
              padding: "1rem",
              backgroundColor: "#f1f5f9",
              justifyContent: "space-evenly",
            }}
          >
            {/* Card 1 */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "280px",
                height: "100px",
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 0 6px rgba(0,0,0,0.08)",
                borderTop: "3px solid #007bff",
                padding: "15px",
                fontFamily: "sans-serif",
              }}
            >
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  background: "linear-gradient(to bottom, #007bff, #00bfff)",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                <img
                  src={AvailableReleaseAmount}
                  alt="icon"
                  style={{ width: "45px", height: "45px" }}
                />
              </div>
              <div>
                <div style={{ fontSize: "14px", color: "#6c757d" }}>
                  {t("Selected Bill Amount:")}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  {Number(selectedBillAmount).toLocaleString("en-IN")}
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "280px",
                height: "100px",
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 0 6px rgba(0,0,0,0.08)",
                borderTop: "3px solid #007bff",
                padding: "15px",
                fontFamily: "sans-serif",
              }}
            >
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  background: "linear-gradient(to bottom, #007bff, #00bfff)",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                <img
                  src={SelectedDemandAmount}
                  alt="icon"
                  style={{
                    width: "45px",
                    height: "45px",
                  }}
                />
              </div>
              <div>
                <div style={{ fontSize: "14px", color: "#6c757d" }}>
                  {t("Selecte Net Payable Amount:")}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  {Number(selectedNetPayableAmount).toLocaleString("en-IN")}
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "280px",
                height: "100px",
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 0 6px rgba(0,0,0,0.08)",
                borderTop: "3px solid #007bff",
                padding: "15px",
                fontFamily: "sans-serif",
              }}
            >
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  background: "linear-gradient(to bottom, #007bff, #00bfff)",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                }}
              >
                <img
                  src={Balance}
                  alt="icon"
                  style={{
                    width: "45px",
                    height: "45px",
                  }}
                />
              </div>
              <div>
                <div style={{ fontSize: "14px", color: "#6c757d" }}>
                  {t("Selected Deduction Amount:")}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  {Number(selectedDeductionAmount).toLocaleString("en-IN")}
                </div>
              </div>
            </div>
          </div>
          <div
            className=" col-12 my-3 px-4"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              className="col-12"
              style={{
                padding: "1px",
                borderRadius: "10px",
                background: "linear-gradient(to right, #2196f3, #9c27b0)",
                display: "inline-block",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  background: "linear-gradient(to right, #c0e4f7, #cdd4f8)",
                  padding: "30px 20px",
                  borderRadius: "8px",
                  fontFamily: "sans-serif",
                }}
              >
                <label
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                    marginRight: "5px",
                  }}
                >
                  {" "}
                  {t("Work Name")}
                </label>
                <select
                  name="ProjectID"
                  id=""
                  value={data.ProjectID}
                  onChange={HandleChangeData}
                  style={{
                    padding: "12px 12px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    outline: "none",
                    width: "830px",
                    fontSize: "14px",
                  }}
                >
                  <option value="All">{t("Choose Work Name")}</option>
                  {projectId &&
                    projectId.map((val, index) => {
                      return (
                        <option key={index} value={val.ProjectName}>
                          {val.ProjectName}
                        </option>
                      );
                    })}
                </select>
                <button
                  style={{
                    backgroundColor: "#28a745",
                    color: "white",
                    border: "none",
                    padding: "10px 18px",
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <span>{t("Search")}</span>
                </button>
              </div>
            </div>
          </div>

          <div
            className="m-auto my-3"
            style={{
              width: "97%",
              backgroundColor: "white",
              borderRadius: "10px",
              padding: "20px 20px",
              boxShadow: "0 0 4px rgba(0,0,0,0.1)",
              fontFamily: "sans-serif",
            }}
          >
            <h4 style={{ marginBottom: "15px", fontWeight: "bold" }}>
              {t("Bill Details")}
            </h4>
            <div
              className="col-12 tableContainer2"
              style={{ overflowX: "scroll" }}
            >
              <table
                className="col-12"
                style={{
                  textAlign: "center",
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#1976d2",
                      color: "white",
                      fontSize: "18px",
                    }}
                  >
                    <th style={{ width: "3%", padding: "18px" }}>
                      <input
                        type="checkbox"
                        style={{ height: "1.2rem", width: "1.2rem" }}
                        checked={selectAll}
                        onChange={handleSelectAllChange}
                      />
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Work Name")}
                    </th>
                    {/* <th style={{ minWidth: "130px", padding: "8px" }}>PIU Name</th> */}
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Demand Number")}
                    </th>
                    <th style={{ width: "6%" }}>{t("Head Code")}</th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("MHUID Number")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Physical Progress in Percentage")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Received Date")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Date")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Amount")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Net Payable Amount")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Deduction")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Vendor Name")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Demand Copy")}
                    </th>
                    {/* <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Invoice Copy")}
                    </th> */}
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Work Order Copy")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Administrative Approved GR (AAGR)")}
                    </th>
                    {AdminData.Department_Name == "State" && (
                      <th style={{ minWidth: "130px", padding: "8px" }}>
                        {t("Upload Order")}
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {currentBills && currentBills.length > 0 ? (
                    currentBills.map((val, index) => {
                      return (
                        <tr key={index} style={{ fontSize: "18px", padding: "18px" }}>
                          <td>
                            <input
                              type="checkbox"
                              style={{ height: "1.2rem", width: "1.2rem" }}
                              checked={selectedBills.includes(
                                val.DemandGenerationID,
                              )}
                              onChange={(e) => {
                                handleCheckboxChange(val.DemandGenerationID);
                                // TotalSelectedDemandAmount(e.target.checked ? val.BillAmount : -val.BillAmount);

                                // if unchecking any one, uncheck master
                                if (!e.target.checked) {
                                  setSelectAll(false);
                                }
                              }}
                            />
                          </td>
                          {/* <td><input type="checkbox" onChange={(e) => TotalSelectedDemandAmount(e.target.checked ? val.BillAmount : -val.BillAmount)} /></td> */}
                          <td>{val.MainWorkOrderID}</td>
                          {/* <td >PIU 1</td> */}
                          <td>
                            <span
                              onClick={() =>
                                openBillSlip(val.DemandGenerationID)
                              }
                              style={{
                                color: "#0d6efd",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontWeight: 500,
                              }}
                            >
                              {val.DemandGenerationID}
                            </span>
                          </td>
                          <td>{val.BudgetID}</td>
                          <td>{val.MHUID_Number || "-"}</td>
                          {/* <td>{val.physicalValueOfProgress}%</td> */}
                           <td>
                                   <span
                                style={{
                                  color: "blue",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                              onClick={() =>
                                openProgressModal(
                                  val.physicalprogressImage,
                                  val.Location,
                                )
                              }
                            >
                              {val.physicalValueOfProgress}%
                            </span>
                          </td>
                          <td>
                            {val.BillReceivedDate
                              ? new Date(val.BillReceivedDate).toLocaleDateString("en-GB")
                              : "-"}
                          </td>

                          <td style={{ fontSize: "18px" }}>
                            {val.Date
                              ? new Date(val.Date).toLocaleDateString("en-GB")
                              : "-"}
                          </td>
                          <td style={{ fontSize: "18px" }}>₹{Number(val.BillAmount || 0).toLocaleString("en-IN")}</td>
                          <td style={{ fontSize: "18px" }}>₹{Number(val.NetPayableAmount || 0).toLocaleString("en-IN")}</td>
                          <td
                            onClick={() =>
                              DemandDeductionDetailByBillID(
                                val.DemandGenerationID,
                              )
                            }
                          >
                            <p
                              className="makeitlink my-auto"
                              style={{ textAlign: "center" }}
                            >
                              {Number(val.DeductionAmount).toLocaleString()}
                            </p>
                          </td>
                          <td>{val.ContractorName}</td>
                          <td>
                            {val.UploadBillCopy ? (
                              <p className="my-auto">
                                <a
                                  href={`${apiurl}/BillCopyDocsImages/${val.UploadBillCopy}`}
                                  target="_blank"
                                >
                                  {formatFileName(val.UploadBillCopy)}
                                </a>
                              </p>
                            ) : (
                              <p
                                className="text-danger fw-bold my-auto"
                                style={{ fontSize: "12px" }}
                              >
                                {t("No File")}
                              </p>
                            )}
                          </td>
                          {/* <td>
                            {val.BillCopy ? (
                              <p className="my-auto">
                                <a
                                  href={`${apiurl}/BillCopyDocsImages/${val.BillCopy}`}
                                  target="_blank"
                                >
                                  {val.BillCopy}
                                </a>
                              </p>
                            ) : (
                              <p
                                className="text-danger fw-bold my-auto"
                                style={{ fontSize: "12px" }}
                              >
                                No File
                              </p>
                            )}
                          </td> */}
                          <td>
                            {val.CopyofWorkOrder ? (
                              <p>
                                <a
                                  href={`${apiurl}/WorkOrderDocsImages/${val.CopyofWorkOrder}`}
                                  target="_blank"
                                >
                                  {formatFileName(val.CopyofWorkOrder)}
                                </a>
                              </p>
                            ) : (
                              <p
                                className="text-danger fw-bold my-auto"
                                style={{ fontSize: "12px" }}
                              >
                                {t("No File")}
                              </p>
                            )}
                          </td>
                          <td>
                            {val.GRCopy ? (
                              <p>
                                <a
                                  href={`${apiurl}/UploadedGR/${val.GRCopy}`}
                                  target="_blank"
                                >
                                  {formatFileName(val.GRCopy)}
                                </a>
                              </p>
                            ) : (
                              <p
                                className="text-danger fw-bold my-auto"
                                style={{ fontSize: "12px" }}
                              >
                                {t("No File")}
                              </p>
                            )}
                          </td>
                          {AdminData.Department_Name == "State" && (
                            <td className="py-2">
                              {AdminData.RoleID == 24 ? (
                                // SHOW FILE NAME / LINK
                                val.uploadWork ? (
                                  <p className="my-auto">
                                    <a
                                      href={`${apiurl}/UploadWorkFiles/${val.uploadWork}`}
                                      target="_blank"
                                      // rel="noreferrer"
                                    >
                                      {formatFileName(val.uploadWork)}
                                    </a>
                                  </p>
                                ) : (
                                  <p
                                    className="text-danger fw-bold my-auto"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {t("No File")}
                                  </p>
                                )
                              ) : (
                                // SHOW UPLOAD BUTTON
                                <>
                                  <input
                                    type="file"
                                    id={`uploadWork-${index}`}
                                    accept=".pdf,.xls,.xlsx"
                                    style={{ display: "none" }}
                                    onChange={(e) => handleUploadWork(e, val)}
                                  />

                                  <button
                                    type="button"
                                    onClick={() =>
                                      document
                                        .getElementById(`uploadWork-${index}`)
                                        .click()
                                    }
                                    className="m-auto text-center"
                                    style={{
                                      fontWeight: "600",
                                      padding: "8px 6px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      gap: "0.1rem",
                                      background:
                                        "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                      cursor: "pointer",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    {t("Upload Order")}
                                  </button>

                                  {uploadedFiles[val.DemandGenerationID] && (
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        marginTop: "5px",
                                        wordBreak: "break-all",
                                      }}
                                    >
                                      {
                                        uploadedFiles[val.DemandGenerationID]
                                          .name
                                      }
                                    </p>
                                  )}
                                </>
                              )}
                            </td>
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={14}>{t("No data found !!")}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                // padding: " 0px 2.5rem",
                height: "3rem",
                alignItems: "center",
              }}
            >
              <div>
                <p style={{ margin: "0px", color: "black" }}>
                  {t("Showing")} {currentBills?.length} {t("of")}{" "}
                  {ALLtableData?.length} {t("entries")}
                </p>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <GooglePagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />

                <button
                  onClick={() => {
                    setShowAll(!showAll);
                    setCurrentPage(1);
                  }}
                  style={{
                    border: "none",
                    outline: "none",
                    cursor: "pointer",
                    padding: "8px 16px",
                    borderRadius: "20px",
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#fff",
                    background: showAll
                      ? "linear-gradient(135deg, #28a745, #20c997)"
                      : "linear-gradient(135deg, #0067ab, #0098d5)",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    transition: "all 0.3s ease",
                  }}
                >
                  {showAll ? "✓ Showing All" : "View All"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {selectedDemandID && showspecific === 1 && (
        <div
          className="col-12"
          style={{
            backgroundColor: "#EFF3F8",
            height: "90vh",
            overflowX: "hidden",
            overflowY: "scroll",
          }}
        >
          <div className="col-11 m-auto">
            <div className="col-12">
              <div className="col-12 py-3">
                <button
                  className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
                  onClick={() => setShowSpecific(0)}
                >
                  {t("Back")}
                </button>
              </div>

              <div className="col-11 my-4 mx-auto">
                <div className="row">
                  <div className="col-9 my-auto">
                    <h2
                      className="col-10 m-0"
                      style={{
                        color: "#2C78DB",
                        fontWeight: "700",
                        fontSize: "1.4rem",
                      }}
                    >
                      {t("Deduction Data of Bill")} {selectedDemandID}
                    </h2>
                  </div>

                  {/* <div className="col-2 text-end">
                <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("DeductionTable", "Deduction.xlsx")}>Download Excel</button>
              </div> */}
                </div>
              </div>
              <div className="col-12 pb-5">
                <div
                  className="m-auto mb-3"
                  style={{
                    backgroundColor: "white",
                    padding: "40px 40px",
                    boxShadow: "0px 0px 5px 1px #E4E8EC",
                    borderRadius: "20px",
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "hidden",
                  }}
                >
                  <div
                    className="col-12 tableDesign"
                    style={{ background: "#2C78DB", overflowX: "hidden" }}
                  >
                    <table
                      className="m-0 p-0"
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead>
                        <tr
                          style={{
                            color: "white",
                            border: "none",
                            height: "3rem",
                            fontSize: "18px",
                          }}
                        >
                          <th style={{ width: "10%" }}>{t("Sr No")}</th>
                          <th style={{ width: "45%" }}>
                            {t("Deduction Name")}
                          </th>
                          <th style={{ width: "45%", textAlign: "left" }}>
                            {t("Deduction Amount")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {fetchSpecificDemandDeductionDetail &&
                        fetchSpecificDemandDeductionDetail.length > 0 ? (
                          <>
                            {fetchSpecificDemandDeductionDetail
                              .filter(
                                (item) =>
                                  item.TypeOfAmount !== "Total Amount Payable",
                              )
                              .map((val, index) => {
                                const bgColor =
                                  index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                  <tr
                                    key={index}
                                    style={{
                                      backgroundColor: bgColor,
                                      fontSize: "18px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    <td>{index + 1}</td>
                                    <td>{val.TypeOfAmount}</td>
                                    <td style={{ textAlign: "left" }}>
                                      ₹{" "}
                                      {Number(val.TotalAmount).toLocaleString()}
                                    </td>
                                  </tr>
                                );
                              })}

                            <tr
                              style={{
                                fontWeight: "bold",
                                backgroundColor: "#f0f0f0",
                                fontSize: "18px"
                              }}
                            >
                              <td colSpan={2}>{t("Total Deduction Amount")}</td>
                              <td style={{ textAlign: "left" }}>
                                ₹{" "}
                                {
                                  Number(
                                    fetchSpecificDemandDeductionDetail
                                      .filter(
                                        (item) =>
                                          item.TypeOfAmount !==
                                          "Total Amount Payable",
                                      )
                                      .reduce(
                                        (acc, curr) =>
                                          acc +
                                          parseFloat(curr.TotalAmount || 0),
                                        0,
                                      ),
                                  ).toLocaleString()
                                  // .toFixed(2)
                                }
                              </td>
                            </tr>
                          </>
                        ) : (
                          <tr>
                            <td colSpan={5} className="fw-bold">
                              {t("No Data Found !!")}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showProgressModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Physical Progress Images</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowProgressModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="row">
                  {progressData?.length > 0 ? (
                    progressData.map((item, index) => (
                      <div className="col-md-4 mb-3" key={index}>
                        <div
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: "10px",
                            padding: "10px",
                            background: "#fff",
                          }}
                        >
                          {/* <img
                                          src={`${apiurl}/UploadProgressDocsImages/${item.image}`}
                                          alt="progress"
                                          className="img-fluid rounded"
                                          style={{
                                            width: "100%",
                                            maxHeight: "250px",
                                            objectFit: "contain",
                                          }}
                                        /> */}
                          <img
                            src={`${apiurl}/UploadProgressDocsImages/${item?.image}`}
                            alt="Document"
                            style={{
                              width: "120px",
                              cursor: "pointer",
                              maxHeight: "250px",
                              objectFit: "contain",
                            }}
                            onClick={() => {
                              setSelectedImage(
                                `${apiurl}/UploadProgressDocsImages/${item.image}`,
                              );
                              setShowImageModal(true);
                            }}
                          />
                          <div
                            style={{
                              marginTop: "10px",
                              fontSize: "14px",
                              lineHeight: "1.7",
                            }}
                          >
                            <div>
                              📍 <strong>Latitude:</strong>{" "}
                              {item.location?.latitude || "-"}
                            </div>

                            <div>
                              📍 <strong>Longitude:</strong>{" "}
                              {item.location?.longitude || "-"}
                            </div>

                            <div>
                              📅 <strong>Date:</strong>{" "}
                              {item.location?.date || "-"}
                            </div>

                            <div>
                              🕒 <strong>Time:</strong>{" "}
                              {item.location?.time || "-"}
                            </div>

                            <div>
                              ⛰️ <strong>Elevation:</strong>{" "}
                              {item.location?.elevation || "-"} m
                            </div>

                            <div>
                              🎯 <strong>Accuracy:</strong>{" "}
                              {item.location?.accuracy || "-"} m
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No Images Found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
     {showImageModal && ( 
       <div
         onClick={() => setShowImageModal(false)}
         style={{
           position: "fixed",
           top: 0,
           left: 0,
           width: "100%",
           height: "100%",
           backgroundColor: "rgba(0,0,0,0.8)",
           display: "flex",
           justifyContent: "center",
           alignItems: "center",
           zIndex: 9999,
         }}
       >
         {/* Previous Button */}
         <button
           onClick={(e) => {
             e.stopPropagation();
     
             const prevIndex =
               (selectedImageIndex - 1 + progressData.length) %
               progressData.length;
     
             setSelectedImageIndex(prevIndex);
           }}
           style={{
             position: "absolute",
             left: "20px",
             top: "50%",
             transform: "translateY(-50%)",
             fontSize: "30px",
             background: "rgba(0,0,0,0.5)",
             color: "#fff",
             border: "none",
             borderRadius: "50%",
             width: "50px",
             height: "50px",
             cursor: "pointer",
             zIndex: 10001,
           }}
         >
           ❮
         </button>
     
         {/* Close Button */}
         <button
           onClick={(e) => {
             e.stopPropagation();
             setShowImageModal(false);
           }}
           style={{
             position: "absolute",
             top: "20px",
             right: "30px",
             fontSize: "30px",
             color: "#fff",
             background: "transparent",
             border: "none",
             cursor: "pointer",
             zIndex: 10001,
           }}
         >
           ×
         </button>
     
         {/* Current Image */}
         <img
           src={`${apiurl}/UploadProgressDocsImages/${progressData[selectedImageIndex]?.image}`}
           alt="Preview"
           onClick={(e) => e.stopPropagation()}
           style={{
             maxWidth: "85%",
             maxHeight: "85%",
             borderRadius: "8px",
             objectFit: "contain",
           }}
         />
     
         {/* Image Counter */}
         <div
           style={{
             position: "absolute",
             bottom: "20px",
             color: "#fff",
             fontSize: "16px",
             fontWeight: "bold",
             background: "rgba(0,0,0,0.5)",
             padding: "6px 12px",
             borderRadius: "20px",
           }}
         >
           {selectedImageIndex + 1} / {progressData.length}
         </div>
     
         {/* Next Button */}
         {/* <button
           onClick={(e) => {
             e.stopPropagation();
     
             const nextIndex =
               (selectedImageIndex + 1) % progressData.length;
     
             setSelectedImageIndex(nextIndex);
           }}
           style={{
             position: "absolute",
             right: "20px",
             top: "50%",
             transform: "translateY(-50%)",
             fontSize: "30px",
             background: "rgba(0,0,0,0.5)",
             color: "#fff",
             border: "none",
             borderRadius: "50%",
             width: "50px",
             height: "50px",
             cursor: "pointer",
             zIndex: 10001,
           }}
         >
           ❯
         </button> */}
         <button
       onClick={(e) => {
         e.stopPropagation();
     
         const nextIndex =
           (selectedImageIndex + 1) % progressData.length;
     
         setSelectedImageIndex(nextIndex);
       }}
       style={{
         position: "absolute",
         right: "20px",
         top: "50%",
         transform: "translateY(-50%)",
         fontSize: "30px",
         background: "rgba(0,0,0,0.5)",
         color: "#fff",
         border: "none",
         borderRadius: "50%",
         width: "50px",
         height: "50px",
         cursor: "pointer",
         zIndex: 10001,
       }}
     >
       ❯
     </button>
       </div>
     )}
      {showspecific === 2 && (
        <div className="col-12 m-auto">
          <div
            className="col-12 m-auto my-15 mb-10 budgetContainer"
            style={{
              maxHeight: "85vh",
              overflowY: "auto",
              overflowX: "hidden",
              border: "1px solid #ddd",
              borderRadius: "8px",
            }}
          >
            <div className="m-auto budgetElement">
              <div
                className="mt-3 d-flex justify-content-between"
                style={{
                  position: "relative",
                  alignItems: "center",
                  background: "#fff",
                }}
              >
                <div className="d-flex align-items-center gap-2 mb-3">
                  <img
                    src="/Bill-files64.png"
                    alt="Bill Slip"
                    width="26"
                    height="26"
                  />
                  <h5 className="m-0 fw-bold">Bill Slip</h5>
                </div>

                <div className="col-4 pb-3 d-flex justify-content-end gap-2">
                  <button
                    className="btn btn-primary d-flex align-items-center gap-2"
                    style={{
                      borderRadius: "999px",
                      padding: "6px 22px",
                      fontSize: "14px",
                      zIndex: 10,
                    }}
                    onClick={exportBillSlipPDF}
                    disabled={exportingBillSlipPDF}
                  >
                    {exportingBillSlipPDF ? "Exporting..." : "Export PDF"}
                  </button>

                  <button
                    className="btn btn-danger d-flex align-items-center gap-2"
                    style={{
                      borderRadius: "999px",
                      padding: "6px 22px",
                      fontSize: "14px",
                      zIndex: 10,
                    }}
                    onClick={closeBillSlip}
                  >
                    Back
                  </button>
                </div>
              </div>

              <div ref={billSlipRef}>
                <div
                  className="text-center text-white py-3"
                  style={{
                    background: "linear-gradient(90deg, #2b4ea1, #0aa2d6)",
                  }}
                >
                  <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                    Zila Parishad - {selectedBillData.District}
                  </div>
                </div>

                <div className="border border-dark p-1">
                  <table
                    className="table mb-0"
                    style={{ fontSize: "14px", border: "none" }}
                  >
                    <tbody>
                      <tr>
                        <td
                          colSpan={2}
                          className="fw-bold text-center fs-6 p-1"
                        >
                          Bill Slip for RDD
                        </td>
                      </tr>

                      {[
                        ["User Name", `${selectedBillData.UploadedBy ?? "-"}`],
                        [
                          "Demand ID",
                          `${selectedBillData.DemandGenerationID ?? "-"}`,
                        ],
                        [
                          "Bill Creation Date",
                          selectedBillData.UploadedOn
                            ? new Date(
                                selectedBillData.UploadedOn,
                              ).toLocaleDateString()
                            : "-",
                        ],
                        ["Head Code", `${selectedBillData.BudgetID ?? "-"}`],
                        ["Work Name", `${selectedBillData.ProjectID ?? "-"}`],
                        [
                          "Class of Work",
                          `${selectedBillData.classOfWork || selectedBillData.workClass || "-"}`,
                        ],
                        [
                          "Work Approved Year",
                          `${selectedBillData.ProposalYear ?? "-"}`,
                        ],
                        [
                          "Work order date",
                          selectedBillData.WorkOrderDate
                            ? new Date(
                                selectedBillData.WorkOrderDate,
                              ).toLocaleDateString("en-GB")
                            : "-",
                        ],
                        [
                          "Work Approved Amount",
                          `${selectedBillData.ApprovedWorkAmount ?? "-"}`,
                        ],
                        [
                          "Gross Bill Amount",
                          `${selectedBillData.BillAmount ?? "-"}`,
                        ],
                        [
                          "R.A.Bill No:",
                          `${selectedBillData.RABillNumber ?? "-"}`,
                        ],
                        [
                          "Invoice Bill No",
                          `${selectedBillData.InvoiceNo ?? "-"}`,
                        ],
                      ].map(([label, value], index) => (
                        <tr
                          key={index}
                          style={{ border: "1.5px solid #1190CA" }}
                        >
                          <td
                            className="text-start"
                            style={{
                              width: "30%",
                              backgroundColor: "#EAF3FB",
                              fontWeight: 500,
                              padding: "6px 10px",
                              borderRight: "1.5px solid #1190CA",
                            }}
                          >
                            {label}
                          </td>
                          <td
                            className="text-start"
                            style={{
                              width: "70%",
                              padding: "6px 10px",
                              backgroundColor: "#FFFFFF",
                            }}
                          >
                            {value}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <table
                    className="mt-1"
                    style={{
                      borderCollapse: "collapse",
                      border: "1px solid #000",
                    }}
                  >
                    <tbody>
                      <tr className="border border-dark">
                        <td
                          className="text-start border border-dark"
                          style={{ width: "30%" }}
                        >
                          Bill Amount
                        </td>
                        <td
                          className="text-start border border-dark"
                          style={{ width: "23%" }}
                        >
                          Deduction Amount
                        </td>
                        <td
                          className="text-start border border-dark"
                          style={{ width: "24%" }}
                        >
                          Net Payable
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start border border-dark">
                          {selectedBillData.BillAmount}
                        </td>
                        <td className="text-start border border-dark">
                          {selectedBillData.DeductionAmount}
                        </td>
                        <td className="text-start border border-dark">
                          {selectedBillData.NetPayableAmount}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table
                    className="mt-2"
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "13px",
                    }}
                  >
                    <tbody>
                      <tr
                        style={{
                          border: "1.5px solid #1190CA",
                          backgroundColor: "#EAF3FB",
                        }}
                      >
                        <td
                          colSpan="6"
                          style={{
                            padding: "8px 10px",
                            fontWeight: 600,
                            textAlign: "center",
                          }}
                        >
                          Vendor Details
                        </td>
                      </tr>
                      <tr style={{ border: "1.5px solid #1190CA" }}>
                        <td
                          style={{
                            padding: "6px 8px",
                            fontWeight: 500,
                            backgroundColor: "#1190CA",
                            color: "white",
                          }}
                        >
                          Vendor Name
                        </td>
                        <td
                          style={{
                            padding: "6px 8px",
                            fontWeight: 500,
                            backgroundColor: "#1190CA",
                            color: "white",
                          }}
                        >
                          IFSC Code
                        </td>
                        <td
                          style={{
                            padding: "6px 8px",
                            fontWeight: 500,
                            backgroundColor: "#1190CA",
                            color: "white",
                          }}
                        >
                          Branch Name
                        </td>
                        <td
                          style={{
                            padding: "6px 8px",
                            fontWeight: 500,
                            backgroundColor: "#1190CA",
                            color: "white",
                          }}
                        >
                          Bank Name
                        </td>
                        <td
                          style={{
                            padding: "6px 8px",
                            fontWeight: 500,
                            backgroundColor: "#1190CA",
                            color: "white",
                          }}
                        >
                          Account Number
                        </td>
                        <td
                          style={{
                            padding: "6px 8px",
                            fontWeight: 500,
                            backgroundColor: "#1190CA",
                            color: "white",
                          }}
                        >
                          Amount
                        </td>
                      </tr>

                      {fetchSpecificDemandDeductionDetail
                        ?.filter(
                          (val) => val.TypeOfAmount == "Total Amount Payable",
                        )
                        .map((val, index) => (
                          <tr
                            style={{ border: "1.5px solid #1190CA" }}
                            key={index}
                          >
                            <td
                              style={{
                                padding: "6px 8px",
                                backgroundColor: "white",
                              }}
                            >
                              {val.Vendor_Company_Name}
                            </td>
                            <td
                              style={{
                                padding: "6px 8px",
                                backgroundColor: "white",
                              }}
                            >
                              {val.Bank_IFSC_Code}
                            </td>
                            <td
                              style={{
                                padding: "6px 8px",
                                backgroundColor: "white",
                              }}
                            >
                              {val.Branch_Name}
                            </td>
                            <td
                              style={{
                                padding: "6px 8px",
                                backgroundColor: "white",
                              }}
                            >
                              {val.BANK_NAME}
                            </td>
                            <td
                              style={{
                                padding: "6px 8px",
                                backgroundColor: "white",
                              }}
                            >
                              {val.Bank_Account_Number}
                            </td>
                            <td
                              style={{
                                padding: "6px 8px",
                                backgroundColor: "white",
                              }}
                            >
                              {val.TotalAmount}
                            </td>
                          </tr>
                        ))}

                      <tr style={{ border: "1.5px solid #1190CA" }}>
                        <td
                          style={{
                            padding: "6px 8px",
                            backgroundColor: "#EAF3FB",
                            fontWeight: 500,
                          }}
                          colSpan={5}
                        >
                          Total
                        </td>
                        <td className="border border-dark">
                          {selectedBillData.NetPayableAmount}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table
                    className="my-2"
                    style={{ width: "100%", borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr
                        style={{
                          border: "1.5px solid #1190CA",
                          backgroundColor: "#EAF3FB",
                        }}
                      >
                        <td
                          colSpan="6"
                          style={{
                            padding: "8px 10px",
                            fontWeight: 600,
                            textAlign: "center",
                          }}
                        >
                          Deduction Amount Details
                        </td>
                      </tr>
                      <tr
                        style={{
                          color: "white",
                          border: "none",
                          height: "3rem",
                        }}
                      >
                        <th style={{ minWidth: "60px", padding: "8px" }}>
                          Sr No
                        </th>
                        <th style={{ minWidth: "60px", padding: "8px" }}>
                          Deduction Type
                        </th>
                        <th style={{ minWidth: "60px", padding: "8px" }}>
                          Deduction Amount
                        </th>
                        <th style={{ minWidth: "60px", padding: "8px" }}>
                          Account Number
                        </th>
                        <th style={{ minWidth: "60px", padding: "8px" }}>
                          Bank Name
                        </th>
                        <th style={{ minWidth: "60px", padding: "8px" }}>
                          IFSC
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {fetchSpecificDemandDeductionDetail.filter(
                        (val) => val.TypeOfAmount != "Total Amount Payable",
                      )?.length == 0 ? (
                        <tr>
                          <td
                            colSpan="30"
                            style={{
                              textAlign: "center",
                              padding: "20px",
                              backgroundColor: "#f9f9f9",
                            }}
                          >
                            No data available
                          </td>
                        </tr>
                      ) : (
                        fetchSpecificDemandDeductionDetail
                          .filter(
                            (val) => val.TypeOfAmount != "Total Amount Payable",
                          )
                          .map((row, index) => {
                            const bgColor =
                              index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                            return (
                              <tr
                                key={index}
                                style={{
                                  borderBottom: "1px solid #3b409e",
                                  backgroundColor: bgColor,
                                  fontSize: "13px",
                                }}
                              >
                                <td style={{ padding: "5px" }}>{index + 1}</td>
                                <td style={{ padding: "5px" }}>
                                  {row.TypeOfAmount}
                                </td>
                                <td style={{ padding: "5px" }}>
                                  {row.TotalAmount}
                                </td>
                                <td style={{ padding: "5px" }}>
                                  {row.Bank_Account_Number}
                                </td>
                                <td style={{ padding: "5px" }}>
                                  {row.Bank_Name}
                                </td>
                                <td style={{ padding: "5px" }}>
                                  {row.Bank_IFSC_Code}
                                </td>
                              </tr>
                            );
                          })
                      )}
                      <tr
                        style={{
                          border: "1.5px solid #1190CA",
                          fontWeight: 600,
                          background: "white",
                        }}
                      >
                        <td
                          colSpan="2"
                          style={{ padding: "6px 8px", textAlign: "right" }}
                        >
                          Total
                        </td>
                        <td style={{ padding: "6px 8px" }}>
                          {selectedBillData.DeductionAmount}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table style={footerTitleStyle}>
                    <tbody>
                      <tr>
                        <td style={footerTitleTdStyle}>मागील देयक तपशील</td>
                      </tr>
                    </tbody>
                  </table>
                  <table style={remarksTableStyle}>
                    <tbody>
                      <tr>
                        <td style={remarksTableTdStyle}>
                          प्रमाणित करण्यात येते की मा देयकाद्वारे आहारीत करण्यात
                          येत असलेली संपूर्ण रक्कम याच जिल्हात खर्च करण्यात
                          येणार आहे.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table style={remarksTableStyle}>
                    <tbody>
                      <tr>
                        <td style={remarksTableTdStyle}>
                          स्वाक्षरी आहरण व संवितरण अधिकारी
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table style={instructionTableStyle}>
                    <tbody>
                      <tr>
                        <td style={instructionTableTdStyle}>
                          दुबार देयक प्रतिबंध नोंदवही तपासणीच्या आधारे प्रमाणित
                          करण्यात येते की या देयकात नमूद केलेल्या अधिकाऱ्याचे
                          कर्मचाऱ्याचे / पुरवठादाराचे तसेच त्यात नमूद केलेल्या
                          बाबीचे / कालावधीचे देयक यापूर्वी ग्रामविकास विभाग मुबई
                          येथे सादर करण्यात आले नव्हते.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ECSGeneration;
